{
  "nav": {
    "dashboard": "डैशबोर्ड",
    "exams": "परीक्षाएं",
    "tests": "मेरे टेस्ट",
    "results": "परिणाम",
    "leaderboard": "लीडरबोर्ड",
    "credits": "क्रेडिट",
    "admin": "व्यवस्थापक",
    "logout": "साइन आउट"
  },
  "auth": {
    "sign_in": "साइन इन करें",
    "sign_up": "साइन अप करें",
    "email": "ईमेल",
    "password": "पासवर्ड",
    "forgot_password": "पासवर्ड भूल गए?"
  },
  "common": {
    "save": "सहेजें",
    "cancel": "रद्द करें",
    "delete": "हटाएं",
    "edit": "संपादित करें",
    "loading": "लोड हो रहा है…",
    "confirm": "क्या आप सुनिश्चित हैं?",
    "search": "खोजें",
    "filter": "फ़िल्टर",
    "back": "वापस",
    "next": "अगला",
    "previous": "पिछला",
    "submit": "सबमिट करें",
    "yes": "हां",
    "no": "नहीं"
  },
  "theme": {
    "dark": "डार्क",
    "light": "लाइट",
    "system": "सिस्टम"
  },
  "test": {
    "start": "टेस्ट शुरू करें",
    "reattempt": "फिर से प्रयास करें",
    "submit": "टेस्ट सबमिट करें",
    "time_remaining": "शेष समय",
    "question": "प्रश्न",
    "marked_for_review": "समीक्षा के लिए चिह्नित",
    "answered": "उत्तरित",
    "not_answered": "अनुत्तरित",
    "not_visited": "नहीं देखा"
  },
  "credits": {
    "balance": "क्रेडिट बैलेंस",
    "purchase": "एक्सेस खरीदें",
    "cost": "{{count}} क्रेडिट",
    "insufficient": "अपर्याप्त क्रेडिट"
  }
}
